import { showModal, hideModal, showNotification } from '../../../utils.js';
import CompanyService from '../../../services/company.js';
import { PhoneInput } from '../../components/PhoneInput.js';

export const setupCompanyModal = (company, onSuccess) => {
    const isEdit = !!company;
    
    // Helper function to escape HTML attributes
    const escapeHtml = (value) => {
        if (!value && value !== 0) return '';
        // Convert to string first
        const str = String(value);
        return str
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    };
    
    const template = `
        <h3 class="text-lg font-bold mb-4">${isEdit ? 'Редактировать' : 'Добавить новый'} Магазин</h3>
        <form id="company-form" class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-700">Kaspi ID</label>
                <input type="text" name="kaspi_uid" required value="${escapeHtml(company?.kaspi_uid || '')}"
                       class="p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                       ${isEdit ? 'readonly disabled' : ''}>
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700">Название магазина/компании ${isEdit ? '<span class="text-green-600 text-xs">(можно изменить)</span>' : ''}</label>
                <input type="text" name="name" required value="${escapeHtml(company?.name || '')}"
                       class="p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white"
                       placeholder="Введите название компании">
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700">Ключ токена</label>
                <input type="password" name="token_key" required value="${escapeHtml(company?.token_key || '')}"
                       class="p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                       ${isEdit ? 'readonly disabled' : ''}>
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700">WhatsApp Телефон</label>
                <div class="mt-1">
                    <input type="tel" name="whatsapp_phone" required value="${escapeHtml(company?.whatsapp_phone || '')}"
                           class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${company?.whatsapp_status === 'connected' ? 'bg-gray-100' : ''}"
                           ${company?.whatsapp_status === 'connected' ? 'readonly' : ''}>
						    <p class="mt-1 text-sm text-gray-500">Формат: 7 (XXX) XXX XXXX</p>
                    ${company?.whatsapp_status === 'connected' ? `
                    <p class="mt-1 text-sm text-red-600">
                        Чтобы изменить номер телефона, сначала отключите WhatsApp.
                    </p>` : ''}
                </div>
            </div>
            <div class="border-t pt-4 mt-4">
                <h4 class="text-md font-medium text-gray-700 mb-3">Настройки рассылки</h4>
                ${company?.whatsapp_status !== 'connected' ? `
                <p class="text-sm text-red-600 mb-3">
                    Настройки рассылки доступны только после подключения WhatsApp.
                </p>` : ''}
                <div class="space-y-4">
                    <div class="space-y-2">
                        <div class="flex items-center">
                            <input type="checkbox" name="mailing_enabled" id="mailing_enabled"
                                   class="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}"
                                   ${company?.mailing_enabled ? 'checked' : ''}
                                   ${company?.whatsapp_status !== 'connected' ? 'disabled' : ''}>
                            <label for="mailing_enabled" class="ml-2 block text-sm font-medium text-gray-700 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}">
                                Включить автоматическую рассылку WhatsApp
                            </label>
                        </div>
                        <div class="flex items-center">
                            <input type="checkbox" name="test_mode" id="test_mode"
                                   class="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}"
                                   ${isEdit ? (company?.test_mode ? 'checked' : '') : 'checked'}
                                   ${company?.whatsapp_status !== 'connected' ? 'disabled' : ''}>
                            <label for="test_mode" class="ml-2 block text-sm font-medium text-gray-700 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}">
                                Включить тестовый режим
                            </label>
                            <div class="ml-1 group relative">
                                <svg class="w-4 h-4 text-gray-400 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <div class="hidden group-hover:block absolute z-10 w-64 p-2 bg-gray-800 text-white text-xs rounded shadow-lg -top-2 left-6">
                                    Когда тестовый режим включен, все сообщения WhatsApp будут отправляться на ваш номер WhatsApp вместо клиентов
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}">Время начала</label>
                            <input type="time" name="mailing_start_time" 
                                   value="${company?.mailing_start_time || '07:00'}"
                                   class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${company?.whatsapp_status !== 'connected' ? 'bg-gray-100' : ''}"
                                   ${company?.whatsapp_status !== 'connected' ? 'disabled' : ''}>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 ${company?.whatsapp_status !== 'connected' ? 'opacity-50' : ''}">Время окончания</label>
                            <input type="time" name="mailing_end_time"
                                   value="${company?.mailing_end_time || '22:00'}"
                                   class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${company?.whatsapp_status !== 'connected' ? 'bg-gray-100' : ''}"
                                   ${company?.whatsapp_status !== 'connected' ? 'disabled' : ''}>
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit"
                    class="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                ${isEdit ? 'Обновить настройки магазина' : 'Добавить магазин'} 
            </button>
        </form>
    `;
    
    showModal(template);

    // Initialize phone input
    const phoneInput = new PhoneInput(
        document.querySelector('input[name="whatsapp_phone"]'),
        { defaultCountry: 'KZ' }
    );

    document.getElementById('company-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const mailingData = {
            mailing_enabled: formData.get('mailing_enabled') === 'on',
            mailing_start_time: formData.get('mailing_start_time') || '07:00',
            mailing_end_time: formData.get('mailing_end_time') || '22:00',
            test_mode: formData.get('test_mode') === 'on'
        };

        const companyData = isEdit ? {
            name: formData.get('name'),
            whatsapp_phone: formData.get('whatsapp_phone'),
            ...mailingData
        } : {
            kaspi_uid: parseInt(formData.get('kaspi_uid')),
            name: formData.get('name'),
            token_key: formData.get('token_key'),
            whatsapp_phone: formData.get('whatsapp_phone'),
            ...mailingData
        };

        try {
            // Validate phone number before submission
            if (!phoneInput.validatePhone()) {
                showNotification('Пожалуйста, введите корректный номер телефона', 'error');
                return;
            }

            if (isEdit) {
                await CompanyService.updateCompany(company.id, companyData);
                showNotification('Данные успешно обновлены');
            } else {
                await CompanyService.createCompany(companyData);
                showNotification('Компания успешно добавлена');
            }
            await onSuccess();
            phoneInput.destroy(); // Cleanup
            hideModal();
        } catch (error) {
            let errorMessage = error.message;
            if (error.response?.status === 400 && error.response.data?.detail) {
                errorMessage = error.response.data.detail;
            }
            showNotification(errorMessage, 'error');
        }
    });
};
